function toggleMenu(toggleColor) {
  document.body.classList.toggle("side-menu--show");
  const sideMenu = document.querySelector("#side-menu");
  const button = document.querySelector("#menu-button");
  sideMenu.classList.toggle("side-menu__container--show");
  console.log(sideMenu);

  if (toggleColor) {
    button.classList.toggle("menu-button--white");
    button.classList.toggle("menu-button--black");
  }
}

function closeMenu(toggleColor) {
  document.body.classList.toggle("side-menu--show");
  const sideMenu = document.querySelector("#side-menu");
  const button = document.querySelector("#menu-button");
  sideMenu.classList.remove("side-menu__container--show");

  if (toggleColor) {
    button.classList.toggle("menu-button--white");
    button.classList.toggle("menu-button--black");
  }
}
